import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Container,
  Stack,
  Typography,
  Modal,
  Box,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Rating,
} from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import moment from "moment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ImageViewer from "react-simple-image-viewer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "../../../App.css";
import { adminApproveSignup, adminRejectSignup } from "../../../apis";
import { countries } from "country-data";

const SelectedRegManager = ({ currentRequestDetails, handleFetchNewData }) => {
  const handleApproveSignup = async () => {
    await adminApproveSignup({
      serviceProviderId: currentRequestDetails.serviceProvider._id,
    });
    handleFetchNewData();
  };
  const handleRejectSignup = async () => {
    await adminRejectSignup({
      serviceProviderId: currentRequestDetails.serviceProvider._id,
    });
    handleFetchNewData();
  };
  return (
    <>
      <Container style={{ background: "#FAFBFE", height: "100%" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack>
            <h2>Service Provider Details</h2>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={4}>
            <ShareOutlinedIcon />
            <FavoriteBorderOutlinedIcon />
          </Stack>
        </Stack>
        <Grid container>
          <Grid item sm={2}>
            <AccountCircleIcon
              style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
            />
          </Grid>
          <Grid item sm={10}>
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <Stack spacing={1} className="mb-5">
                  <Typography
                    style={{ fontWeight: "bold", textTransform: "capitalize" }}
                  >
                    {currentRequestDetails.serviceProvider.fullName}
                  </Typography>
                  <Typography className="ammanat-darker-gray">
                    {currentRequestDetails.serviceProvider.email}
                  </Typography>
                  {/* <CheckCircleIcon
                    style={{ height: "15px", width: "15px", color: "#FA8319" }}
                  /> */}
                </Stack>

                <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                  Country
                </Typography>
                <Typography className="mb-10 ammanat-darker-gray">
                  {
                    countries[currentRequestDetails.serviceProvider.country]
                      .name
                  }
                </Typography>
              </Stack>

              <div
                style={{ background: "white", padding: "20px", width: "200px" }}
              >
                {/* <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{ marginBottom: "20px" }}
                >
                  <Typography style={{ color: "#7A7A80" }}>Charges</Typography>
                  <Typography style={{ fontWeight: "bold" }}>£35</Typography>
                </Stack> */}
                <Stack spacing={2} alignItems="center">
                  <Button
                    variant="contained"
                    className="primary-button"
                    style={{
                      textTransform: "capitalize",
                      width: "168px",
                    }}
                    onClick={handleApproveSignup}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="outlined"
                    className="report-button"
                    style={{ textTransform: "capitalize", width: "168px" }}
                    onClick={handleRejectSignup}
                  >
                    Reject
                  </Button>
                </Stack>
              </div>
            </Stack>

            <Stack>
              <Typography
                className="mt-16"
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                Personal Info
              </Typography>
            </Stack>

            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Account Type
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {
                  currentRequestDetails.serviceProviderInfo.personalInfo
                    .accountType
                }
              </Typography>
            </Stack>
            {currentRequestDetails.serviceProviderInfo.personalInfo
              .accountType == "Sole Trader" ? (
              <>
                <Stack>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    Trader Name
                  </Typography>
                  <Typography variant="body1" className="ammanat-darker-gray">
                    {
                      currentRequestDetails.serviceProviderInfo.personalInfo
                        .traderName
                    }
                  </Typography>
                </Stack>
                <Stack>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    VAT Number
                  </Typography>
                  <Typography variant="body1" className="ammanat-darker-gray">
                    {
                      currentRequestDetails.serviceProviderInfo.personalInfo
                        .VATNumber
                    }
                  </Typography>
                </Stack>
              </>
            ) : currentRequestDetails.serviceProviderInfo.personalInfo
                .accountType == "Company" ? (
              <>
                <Stack>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    Company Name
                  </Typography>
                  <Typography variant="body1" className="ammanat-darker-gray">
                    {
                      currentRequestDetails.serviceProviderInfo.personalInfo
                        .companyName
                    }
                  </Typography>
                </Stack>
                <Stack>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    Company Reg Number
                  </Typography>
                  <Typography variant="body1" className="ammanat-darker-gray">
                    {
                      currentRequestDetails.serviceProviderInfo.personalInfo
                        .companyRegistrationNumber
                    }
                  </Typography>
                </Stack>
                <Stack>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    VAT Number
                  </Typography>
                  <Typography variant="body1" className="ammanat-darker-gray">
                    {
                      currentRequestDetails.serviceProviderInfo.personalInfo
                        .VATNumber
                    }
                  </Typography>
                </Stack>
              </>
            ) : (
              <></>
            )}
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Address
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {currentRequestDetails.serviceProviderInfo.personalInfo.address}
              </Typography>
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Title
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {
                  currentRequestDetails.serviceProviderInfo.personalInfo
                    .jobTitle
                }
              </Typography>
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Description
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {
                  currentRequestDetails.serviceProviderInfo.personalInfo
                    .description
                }
              </Typography>
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Phone Number
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {
                  currentRequestDetails.serviceProviderInfo.personalInfo
                    .phoneNumber
                }
              </Typography>
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Images
              </Typography>
              <Grid container spacing={2}>
                {currentRequestDetails.serviceProviderInfo.personalInfo.image.map(
                  (item) => (
                    <Grid item sm={4}>
                      <img
                        src={item}
                        style={{
                          width: "150px",
                          height: "150px",
                          cursor: "pointer",
                          objectFit: "contain",
                        }}
                      />
                    </Grid>
                  )
                )}
              </Grid>
            </Stack>
            <Stack>
              <Typography
                className="mt-16"
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                Expertise
              </Typography>
            </Stack>

            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Category
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {`${currentRequestDetails.serviceProviderInfo.expertise.category} | ${currentRequestDetails.serviceProviderInfo.expertise.subCategory}`}
              </Typography>
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Skills
              </Typography>
              <Grid container spacing={2} className="mt-10">
                {currentRequestDetails.serviceProviderInfo.expertise.skills.map(
                  (item) => (
                    <Grid item sm={4}>
                      <Typography
                        className="ammanat-darker-gray skill-pill"
                        style={{ fontSize: "13px" }}
                      >
                        {item.label}
                      </Typography>
                    </Grid>
                  )
                )}
              </Grid>
            </Stack>

            {/* <Stack>
              <Typography
                className="mt-16"
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                Documents
              </Typography>
            </Stack> */}
            <Stack>
              <Typography
                className="mt-16"
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                Certifications
              </Typography>
              {currentRequestDetails.serviceProviderInfo.documents.certificationData.map(
                (item) => (
                  <>
                    <Typography
                      className="mt-16"
                      style={{ fontWeight: "bold" }}
                    >
                      Certificate Name
                    </Typography>
                    <Typography variant="body1" className="ammanat-darker-gray">
                      {item.certificationName}
                    </Typography>
                    <Stack spacing={3} direction="row">
                      <Stack>
                        <Typography
                          className="mt-16"
                          style={{ fontWeight: "bold" }}
                        >
                          Start Date
                        </Typography>
                        <Typography
                          variant="body1"
                          className="ammanat-darker-gray"
                        >
                          {item.startDate}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography
                          className="mt-16"
                          style={{ fontWeight: "bold" }}
                        >
                          End Date
                        </Typography>
                        <Typography
                          variant="body1"
                          className="ammanat-darker-gray"
                        >
                          {item.endDate}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack>
                      <Typography
                        className="mt-16"
                        style={{ fontWeight: "bold" }}
                      >
                        Certificate Image
                      </Typography>
                      <Grid container spacing={2}>
                        {item.certificationImages.map((image) => (
                          <Grid item sm={4}>
                            <img
                              src={image}
                              style={{
                                width: "150px",
                                height: "150px",
                                cursor: "pointer",
                                objectFit: "contain",
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Stack>
                  </>
                )
              )}
            </Stack>
            <Stack>
              <Typography
                className="mt-16"
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                Proof of Address
              </Typography>
              <Grid container spacing={2}>
                {currentRequestDetails.serviceProviderInfo.documents.pofImages.map(
                  (pof) => (
                    <Grid item sm={4}>
                      <img
                        src={pof}
                        style={{
                          width: "150px",
                          height: "150px",
                          cursor: "pointer",
                          objectFit: "contain",
                        }}
                      />
                    </Grid>
                  )
                )}
              </Grid>
            </Stack>
            <Stack className="mb-16">
              <Typography
                className="mt-16"
                style={{ fontWeight: "bold", fontSize: "22px" }}
              >
                Photo ID
              </Typography>
              <Grid container spacing={2}>
                {currentRequestDetails.serviceProviderInfo.documents.photoID.map(
                  (photoID) => (
                    <Grid item sm={4}>
                      <img
                        src={photoID}
                        style={{
                          width: "150px",
                          height: "150px",
                          cursor: "pointer",
                          objectFit: "contain",
                        }}
                      />
                    </Grid>
                  )
                )}
              </Grid>
            </Stack>
            {/* {currentRequest.images.length ? (
            <Stack>
              <h4>Images and Videos</h4>
              {currentRequest.images.map((item, index) => (
                <img
                  src={item}
                  style={{
                    height: "120px",
                    width: "120px",
                    cursor: "pointer",
                  }}
                  onClick={() => openImageViewer(index)}
                />
              ))}
              {isViewerOpen && (
                <ImageViewer
                  src={currentRequest.images}
                  currentIndex={currentImage}
                  onClose={closeImageViewer}
                  disableScroll={true}
                  backgroundStyle={{
                    backgroundColor: "rgba(0,0,0,0.9)",
                  }}
                  closeOnClickOutside={true}
                />
              )}
            </Stack>
          ) : (
            <></>
          )} */}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SelectedRegManager;
